<div role="navigation" tabindex="0" aria-label="Global Navigation Menu" class="topnav" id="myTopnav">

  <a tabindex="0" alt="Link to view Home" title="Home" aria-label="Link to view Home" class="btn"
    [routerLink]="['/']" (click)="CollapseMenu()">Home</a>

  <a tabindex="0" alt="Link to view Dashboard" title="Dashboard" aria-label="Link to view Dashboard" class="btn"
    [routerLink]="['/dashboard']" (click)="CollapseMenu()">Dashboard</a>

    <ng-container>
      <a tabindex="0" alt="Link to view Community Goals" title="Community Goals" onclick="window.open('https://nonprofits.coj.net/StrategicPartnerships/CommunityGoalsFramework.aspx','_blank')"
      aria-label="Link to view Community Goals" class="btn" style="cursor: pointer;">Community Goals </a>
      </ng-container>

    <ng-container>
      <a tabindex="0" class="btn" alt="Link to view Resources" title="Resources"
        aria-label="Link to view Resources"  [routerLink]="['/Resources']"  (click)="CollapseMenu()">Resources</a>
    </ng-container> 


  <ng-container *ngIf="IsAdmin">
    <div class="loginnav">
      <a tabindex="0" alt="User Name" aria-label="User Name" style="color:white;font-size: 13px;" title="{{ UserName }}"
        (click)="CollapseMenu()">{{ UserName }} ({{ Role }})</a>
      <a href="#" class="btn btn-info btn-lg"
        style="background-color:#f5b642; height: 26px; margin-top: 8px; padding-top: 2px; margin-right: 4px;"
        (click)="logoutUser()" tabindex="0" title="Log Out" aria-label="Link to log out" title="Log Out"
        (click)="CollapseMenu()">
        <span class="glyphicon glyphicon-log-out"></span>
        <font color="black">Logout</font>
      </a>
    </div>
  </ng-container>
  <ng-container *ngIf="!IsAdmin">
    <a [routerLink]="['/loginuser']" (click)="CollapseMenu()" class="loginnav" title="For COJ Employees: Click here to
      Login" alt="Link to view login" aria-label="For COJ Employees: Click the link here to view
      Login Page">For COJ Employees: Click here to Login</a>
  </ng-container>
  <a href="javascript:void(0);" title="Menu" aria-label="Click the icon to view menu items" class="icon"
    onclick="myFunction()">
    <i class="fa fa-bars"></i>
  </a>
</div>
